import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {CommunityGetSchema} from '../../../../api/DBSchema/Community';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import Sepperator from '../../../../components/Simple/Sepperator';
import Indentation from '../../../../components/Simple/Indentation';
import SMCNumberInput from '../../../../components/Simple/SMCNumberInput';
import RowLayout from '../../../../components/Layouts/RowLayout';
import {SMCRadio, SMCRadioGroup} from '../../../../components/Simple/SMCRadio';

const pageSchema = CommunityGetSchema;

function CommunityIKESettings({
    communityObject,
    setCommunityData
}) {
    const { t } = useTranslation();

    const pageData = communityObject;
    const setPageValue = useCallback((paramName, value) => {
        setCommunityData(paramName, value);
    }, [setCommunityData]);

    const ikePhase1Encryption               = pageData[pageSchema.ikePhase1Encryption];
    const ikePhase1EncryptionValues         = pageSchema.ikePhase1EncryptionValues;
    const ikePhase1Integrity                = pageData[pageSchema.ikePhase1Integrity];
    const ikePhase1IntegrityValues          = pageSchema.ikePhase1IntegrityValues;
    const ikePhase1DiffieHellmanGroup       = pageData[pageSchema.ikePhase1DiffieHellmanGroup];
    const ikePhase1DiffieHellmanGroupValues = pageSchema.ikePhase1DiffieHellmanGroupValues;
    const ikePhase1SALifetime               = pageData[pageSchema.ikePhase1SALifetime];

    const ikePhase2Encryption               = pageData[pageSchema.ikePhase2Encryption];
    const ikePhase2EncryptionValues         = pageSchema.ikePhase2EncryptionValues;
    const ikePhase2Integrity                = pageData[pageSchema.ikePhase2Integrity];
    const ikePhase2IntegrityValues          = pageSchema.ikePhase2IntegrityValues;
    const ikePhase2SecrecyEnabled           = pageData[pageSchema.ikePhase2SecrecyEnabled];
    const ikePhase2DiffieHellmanGroup       = pageData[pageSchema.ikePhase2DiffieHellmanGroup];
    const ikePhase2DiffieHellmanGroupValues = pageSchema.ikePhase2DiffieHellmanGroupValues;
    const ikePhase2SALifetime               = pageData[pageSchema.ikePhase2SALifetime];
    // const ikePhase2IPCompression            = pageData[pageSchema.ikePhase2IPCompression]; // Not used currently

    // VPN tunnel sharing
    const tunnelType                = pageData[pageSchema.tunnelType];
    const tunnelTypeValues          = pageSchema.tunnelTypeValues;

    return (
        <EditorLayout>
            {/* Ike phase 1 */}
            <SMCLabel bold>{t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.IKE_PHASE1')}</SMCLabel>
            <Sepperator />
            <Indentation>
                {/* Ike1 encryption */}
                <SMCSelect
                    value={ikePhase1Encryption}
                    onChange={e => setPageValue(pageSchema.ikePhase1Encryption, e.target.value)}
                    label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.ENCRYPTION')}
                >
                    <SMCOption value={ikePhase1EncryptionValues.tripleDes}>3DES</SMCOption>
                    <SMCOption value={ikePhase1EncryptionValues.aes128}>AES-128</SMCOption>
                    <SMCOption value={ikePhase1EncryptionValues.aes256}>AES-256</SMCOption>
                    <SMCOption value={ikePhase1EncryptionValues.des}>DES</SMCOption>
                    <SMCOption value={ikePhase1EncryptionValues.cast}>CAST</SMCOption>
                </SMCSelect>
                {/* Ike1 integrity */}
                <SMCSelect
                    value={ikePhase1Integrity}
                    onChange={e => setPageValue(pageSchema.ikePhase1Integrity, e.target.value)}
                    label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.AUTH')}
                >
                    <SMCOption value={ikePhase1IntegrityValues.md5}>MD5</SMCOption>
                    <SMCOption value={ikePhase1IntegrityValues.sha1}>SHA1</SMCOption>
                    <SMCOption value={ikePhase1IntegrityValues.sha256}>SHA256</SMCOption>
                    <SMCOption value={ikePhase1IntegrityValues.aesXcbc}>AES-XCBC</SMCOption>
                </SMCSelect>
                {/* Ike1 Diffie Hellman group */}
                <SMCSelect
                    value={ikePhase1DiffieHellmanGroup}
                    onChange={e => setPageValue(pageSchema.ikePhase1DiffieHellmanGroup, e.target.value)}
                    label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.DIFFIE_HELLMAN_GROUP')}
                >
                    <SMCOption value={ikePhase1DiffieHellmanGroupValues.group1}>Group1</SMCOption>
                    <SMCOption value={ikePhase1DiffieHellmanGroupValues.group2}>Group2</SMCOption>
                    <SMCOption value={ikePhase1DiffieHellmanGroupValues.group5}>Group5</SMCOption>
                    <SMCOption value={ikePhase1DiffieHellmanGroupValues.group14}>Group14</SMCOption>
                </SMCSelect>
                <SMCNumberInput
                    value={ikePhase1SALifetime}
                    onChange={e => setPageValue(pageSchema.ikePhase1SALifetime, parseInt(e.target.value))}
                    label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.RENEGOTIATE_EVERY') + ' ' + t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.MINUTES')}
                />
            </Indentation>
                {/* Ike phase 2 */}
                <SMCLabel bold>{t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.IKE_PHASE2')}</SMCLabel>
                <Sepperator />
                <Indentation>
                    {/* Ike2 encryption */}
                    <SMCSelect
                        value={ikePhase2Encryption}
                        onChange={e => setPageValue(pageSchema.ikePhase2Encryption, e.target.value)}
                        label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.ENCRYPTION')}
                    >
                        <SMCOption value={ikePhase2EncryptionValues.tripleDes}>3DES</SMCOption>
                        <SMCOption value={ikePhase2EncryptionValues.aes128}>AES-128</SMCOption>
                        <SMCOption value={ikePhase2EncryptionValues.aes256}>AES-256</SMCOption>
                        <SMCOption value={ikePhase2EncryptionValues.des}>DES</SMCOption>
                        <SMCOption value={ikePhase2EncryptionValues.cast}>CAST</SMCOption>
                        <SMCOption value={ikePhase2EncryptionValues.des_40cp}>DES-CP40</SMCOption>
                        <SMCOption value={ikePhase2EncryptionValues.cast_40}>CAST-40</SMCOption>
                    </SMCSelect>
                    {/* Ike2 integrity */}
                    <SMCSelect
                        value={ikePhase2Integrity}
                        onChange={e => setPageValue(pageSchema.ikePhase2Integrity, e.target.value)}
                        label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.AUTH')}
                    >
                        <SMCOption value={ikePhase2IntegrityValues.md5}>MD5</SMCOption>
                        <SMCOption value={ikePhase2IntegrityValues.sha1}>SHA1</SMCOption>
                        <SMCOption value={ikePhase2IntegrityValues.sha256}>SHA256</SMCOption>
                        <SMCOption value={ikePhase2IntegrityValues.aesXcbc}>AES-XCBC</SMCOption>
                    </SMCSelect>
                    {/* Perfect forward secrecy */}
                    <SMCSelect
                        value={ikePhase2SecrecyEnabled.toString()}
                        onChange={e => setPageValue(pageSchema.ikePhase2SecrecyEnabled, e.target.value === 'true' ? true : false)}
                        label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.PERFECT_FORWARD_SEC')}
                    >
                        <SMCOption value="false">{t('SMC_GEN_DISABLED')}</SMCOption>
                        <SMCOption value="true">{t('SMC_GEN_ENABLED')}</SMCOption>
                    </SMCSelect>
                    {/* Ike2 Diffie Hellman group */}
                    <SMCSelect
                        disabled={!ikePhase2SecrecyEnabled}
                        value={ikePhase2DiffieHellmanGroup}
                        onChange={e => setPageValue(pageSchema.ikePhase2DiffieHellmanGroup, e.target.value)}
                        label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.DIFFIE_HELLMAN_GROUP')}
                    >
                        <SMCOption value={ikePhase2DiffieHellmanGroupValues.group1}>Group1</SMCOption>
                        <SMCOption value={ikePhase2DiffieHellmanGroupValues.group2}>Group2</SMCOption>
                        <SMCOption value={ikePhase2DiffieHellmanGroupValues.group5}>Group5</SMCOption>
                        <SMCOption value={ikePhase2DiffieHellmanGroupValues.group14}>Group14</SMCOption>
                    </SMCSelect>
                    <SMCNumberInput
                        value={ikePhase2SALifetime}
                        onChange={e => setPageValue(pageSchema.ikePhase2SALifetime, parseInt(e.target.value))}
                        label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.RENEGOTIATE_EVERY') + ' ' + t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.SECONDS')}
                    />
                    {/* VPN Tunnel sharing */}
                    <RowLayout>
                        <SMCLabel
                            useContextWidth={true}
                            tooltip={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.VPN_TUNNEL_SHARING.TOOLTIP')}
                        >
                            {t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.VPN_TUNNEL_SHARING')}
                        </SMCLabel>
                        <SMCRadioGroup
                            value={tunnelType}
                            onChange={e => setPageValue(pageSchema.tunnelType, e.target.value)}
                        >
                            <SMCRadio
                                label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.VPN_TUNNEL_SHARING.RADIO1')}
                                value={tunnelTypeValues.tunnelPerGateway}
                            />
                            <SMCRadio
                                label={t('SMP.COMMUNITIES.TABLE.VPN_SETTINGS.VPN_TUNNEL_SHARING.RADIO2')}
                                value={tunnelTypeValues.tunnelPerSubnet}
                            />
                        </SMCRadioGroup>
                    </RowLayout>
                </Indentation>
        </EditorLayout>
    )
}

export default CommunityIKESettings;